import React from 'react';

export default function ContactusSectionCta5() {
    return (
        <React.Fragment>
            <>
                <section className style={{backgroundImage: 'url("https://static.shuffle.dev/uploads/files/6e/6e0f5129d29c66a42389554d32247ff33a40eeff/istockphoto-1277242852-612x612.jpg")'}}>
  <div className="bg-black bg-opacity-60 py-28" style={{backdropFilter: 'blur(12px)'}}>
    <div className="container px-4 mx-auto">
      <div className="text-center max-w-3xl mx-auto">
        <h2 className="mb-11 text-white font-bold text-center tracking-px-n leading-none text-15xl fontText">Membresias</h2>
        <div className="md:inline-block">
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

